import { render, staticRenderFns } from "./PowerSummarizerView.vue?vue&type=template&id=6dd8e3bc&scoped=true"
import script from "./PowerSummarizerView.vue?vue&type=script&lang=js"
export * from "./PowerSummarizerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd8e3bc",
  null
  
)

export default component.exports